import React, { useEffect, useState } from "react";
import MenuDataAnalytics from "../MenuDataAnalytics";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import PesquisaArtigo from "../PesquisaArtigo";

export default function AnaliseDescritiva() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <NavbarTop />
        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/data-analytics">Data Analytics</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Como acessar a análise descritiva da minha base?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataAnalytics />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Como acessar a análise descritiva da minha base?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Analytics</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conheça seu cliente
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br />

                <p>
                  <h3>
                    <p>
                      <h3>Pessoa Física</h3>
                    </p>
                  </h3>
                </p>

                <p>
                  Para ter acesso a análise descritiva da sua base pessoa
                  física, clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Analisar </a>e em seguida
                  clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases PF</a>:
                </p>

                <figure>
                  <img
                    src="img/perfil_socio_demografico_img_01.png"
                    alt="excel"
                  />
                </figure>

                <figcaption>Gestão de bases</figcaption>

                <p>
                  Agora clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Analise descritiva</a>:
                </p>

                <figure>
                  <img
                    src="img/perfil_socio_demografico_img_02.png"
                    alt="excel"
                  />
                </figure>

                <figcaption>Analise descritiva</figcaption>

                <p>
                  Logo em seguida serão exibidas as informações sócio
                  demográficas, faixas de renda e o risco financeiro de sua base
                  de clientes:
                </p>

                <figure>
                  <img
                    src="img/perfil_socio_demografico_img_03.png"
                    alt="excel"
                  />
                </figure>

                <figcaption>Informações sócio demográficas</figcaption>

                <br></br>

                <p>
                  <h3>
                    <p>
                      <h3>Pessoa Jurídica</h3>
                    </p>
                  </h3>
                </p>

                <p>
                  Para ter acesso a análise descritiva da sua base pessoa
                  jurídica, clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Analisar </a>e em seguida
                  clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Gestão de bases PJ</a>:
                </p>

                <figure>
                  <img
                    src="img/perfil_socio_demografico_pj_img_01.png"
                    alt="excel"
                  />
                </figure>

                <figcaption>Gestão de bases</figcaption>

                <p>
                  Agora clique em{" "}
                  <a style={{ fontWeight: "bold" }}>Analise descritiva</a>:
                </p>

                <figure>
                  <img
                    src="img/perfil_socio_demografico_pj_img_02.png"
                    alt="excel"
                  />
                </figure>

                <figcaption>Analise descritiva</figcaption>

                <p>
                  Logo em seguida serão exibidas as informações sócio
                  demográficas, faturamento presumido, situação cadastral,
                  descrição CNAE e natureza jurídica de sua base de clientes:
                </p>

                <figure>
                  <img
                    src="img/perfil_socio_demografico_pj_img_03.png"
                    alt="excel"
                  />
                </figure>

                <figcaption>Informações sócio demográficas</figcaption>

                <br></br>

                {/* Seção de votos */}

                <div>
                  <PesquisaArtigo />
                </div>
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
